import React from 'react';
import ReactDOM from 'react-dom/client';
import './config/i18n';
import App from './App';
import './App.css';
import { ErrorProvider } from './contexts/ErrorContext';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/id';
import theme from './config/theme';
import Logger from './utils/Logger';

if (process.env.NODE_ENV === 'development') {
  window.Logger = Logger;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorProvider>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
          <App />
        </LocalizationProvider>
      </ThemeProvider>
    </ErrorProvider>
  </React.StrictMode>
);
